import React from 'react';

import { AddIssueTypeButton } from '@qality/common-pages/src/Dashboard/AddIssueTypeButton';

import {
  GadgetExplanationText,
  GadgetLink,
  GedgetConfigStyled,
} from '../gadgets.styled';

const RecentTestCyclesConfigView: React.FC = () => {
  return (
    <>
      <GedgetConfigStyled>
        <GadgetExplanationText>
          Test Cycles without Test Cases will be a bit empty. To start exploring
          Test Cycles, Jira Administrator has to add QAlity Test issue type to
          project.
        </GadgetExplanationText>
        <div>
          <AddIssueTypeButton />
          <GadgetLink
            onClick={() => window.open(plugin.quickStartUrl, '_blank')}
          >
            Learn more
          </GadgetLink>
        </div>
      </GedgetConfigStyled>
    </>
  );
};

export default RecentTestCyclesConfigView;
